import { Form, Typography } from 'antd';
import { useMutation } from '@apollo/client';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import SimpleDialog from '../components/dialogs/SimpleDialog';
import { NoLabelForm, SubmitButton } from '../components/forms/forms';
import { FormItemInputText } from '../components/forms/basicFormElements';
import logoImg from '../resources/img/quick-online-logo-q.svg';
import { SWITCH_USER } from '../app/graphql/authQueries';
import { useSwitchUserDialogStyles } from './SwitchUserDialog.styles';

export default function SwitchUserDialog({ open, close }) {
  const { styles } = useSwitchUserDialogStyles();
  const [form] = Form.useForm();
  const [switchUser] = useMutation(SWITCH_USER);

  const onSubmit = async ({ userId }) => {
    await switchUser({
      variables: {
        input: {
          newUserId: userId,
        },
      },
    });
    window.location.reload();
  };

  return (
    <SimpleDialog
      className={styles.switchUserDialog}
      iconClassName={styles.icon}
      icon={<img src={logoImg} alt="" width={54} height={57} />}
      open={open}
      centered
      mask
      closable
      onCancel={close}
    >
      <Typography.Title level={1} className="sm margin-md">
        <FormattedMessage id="account.switchUser" />
      </Typography.Title>
      <NoLabelForm
        onSubmit={onSubmit}
        form={form}
        className={styles.noMarginFormItems}
      >
        <FormItemInputText
          name="userId"
          rules={[{ required: true }]}
          placeholderId="account.switchUser.placeholder"
          floatingLabel={false}
        />
        <SubmitButton size="large" type="primary" textId="buttons.confirm" />
      </NoLabelForm>
    </SimpleDialog>
  );
}
